import { Avatar, Box, IconButton, Typography } from "@mui/material";
import {
  ContributorsContainer,
  GenresAndContributorsContainer,
  GenresDetailsContainer,
  MessageContainer,
  CollaboratorsStyles,
} from "../styles";
import { NavLink, useNavigate } from "react-router-dom";
import MessageIcon from "@mui/icons-material/Message";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { CollaboratorsProps } from "../types";
import { isMobile } from "react-device-detect";
import { ENTERPRISE_ARTWORK_TEMPLATE, isEnterprise } from "../../../theme";
import { TEXT_COLOR } from "../../../theme";
import { APP_COLOR, FONT_FAMILY } from "../../../theme";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { useState } from "react";

const CustomizedTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: APP_COLOR,
    color: "white",
    boxShadow: theme.shadows[1],
    fontSize: 12,
    borderRadius: 10,
    fontFamily: FONT_FAMILY,
    padding: 8,
  },
}));

export const Collaborators: React.FC<CollaboratorsProps> = ({
  genres,
  contributors,
  bpm,
  handleOpenCollabsModal,
  id,
  handleCreateGroupChat,
  trackTitle,
  isTrackConnectedToTutorial,
}) => {
  const [isToolTipOpen, setIsToolTipOpen] = useState(false);
  const navigate = useNavigate();
  const isSharedContentPage = window.location.pathname.includes("/share/");

  const handleToolTipClicked = (e: any) => {
    e.stopPropagation();
    setIsToolTipOpen(true);
  };

  return (
    <GenresAndContributorsContainer>
      <GenresDetailsContainer>
        <Box style={CollaboratorsStyles.genreDetailsBox}>
          {bpm !== undefined && bpm !== 0 && (
            <Typography noWrap sx={CollaboratorsStyles.genreText}>
              <span style={CollaboratorsStyles.genreLabel}>BPM: </span>
              {bpm}
            </Typography>
          )}

          <Typography noWrap sx={CollaboratorsStyles.genreText}>
            <span style={CollaboratorsStyles.genreLabel}>Genre: </span>{" "}
            {genres && genres}
            {!genres && "Unknown"}
          </Typography>
        </Box>
      </GenresDetailsContainer>

      {isMobile ? (
        <CustomizedTooltip
          style={{ cursor: "pointer" }}
          title={
            <Box sx={{ display: "flex" }}>
              {contributors &&
                contributors.map((el) => {
                  const userProfileRoute = `/user-profile/${el.getUsername()}`;
                  return (
                    <CustomizedTooltip
                      title={el.getUsername()}
                      key={el.getUserId()}
                      placement="top"
                    >
                      <NavLink
                        to={userProfileRoute}
                        state={{ userId: el.getUserId() }}
                        style={CollaboratorsStyles.navLinkAvatar}
                        key={el.getUserId()}
                      >
                        <Avatar
                          style={CollaboratorsStyles.contributorsPhotos}
                          src={
                            el.getProfilePicture()
                              ? el.getProfilePicture()
                              : isEnterprise
                              ? ENTERPRISE_ARTWORK_TEMPLATE
                              : "/assets/images/logo512.png"
                          }
                          onClickCapture={() => {
                            navigate(`/user-profile/${el.getUsername()}`);
                          }}
                          alt={el.getUsername()}
                        />
                      </NavLink>
                    </CustomizedTooltip>
                  );
                })}
            </Box>
          }
          placement="top-end"
          open={isToolTipOpen}
          onClose={() => setIsToolTipOpen(false)}
        >
          <ContributorsContainer max={2} onClick={handleToolTipClicked}>
            {contributors &&
              contributors
                .filter((c: any) => c.getUsername())
                .map((contributor: any) => {
                  return (
                    <Tooltip
                      key={contributor.getUsername()}
                      title={contributor.getUsername()}
                      placement="top"
                    >
                      <Avatar
                        style={CollaboratorsStyles.contributorsPhotos}
                        src={
                          contributor.getProfilePicture()
                            ? contributor.getProfilePicture()
                            : isEnterprise
                            ? ENTERPRISE_ARTWORK_TEMPLATE
                            : "/assets/images/logo512.png"
                        }
                        onClickCapture={() => {
                          navigate(
                            `/user-profile/${contributor.getUsername()}`
                          );
                        }}
                        alt={contributor.getUsername()}
                      />
                    </Tooltip>
                  );
                })}
          </ContributorsContainer>
        </CustomizedTooltip>
      ) : contributors && contributors.length > 4 ? (
        <CustomizedTooltip
          style={{ cursor: "pointer" }}
          title={
            <Box sx={{ display: "flex" }}>
              {contributors.map((el) => {
                const userProfileRoute = `/user-profile/${el.getUsername()}`;
                return (
                  <CustomizedTooltip
                    title={el.getUsername()}
                    key={el.getUserId()}
                    placement="top"
                  >
                    <NavLink
                      to={userProfileRoute}
                      state={{ userId: el.getUserId() }}
                      style={CollaboratorsStyles.navLinkAvatar}
                      key={el.getUserId()}
                    >
                      <Avatar
                        style={CollaboratorsStyles.contributorsPhotos}
                        src={
                          el.getProfilePicture()
                            ? el.getProfilePicture()
                            : isEnterprise
                            ? ENTERPRISE_ARTWORK_TEMPLATE
                            : "/assets/images/logo512.png"
                        }
                        onClickCapture={() => {
                          navigate(`/user-profile/${el.getUsername()}`);
                        }}
                        alt={el.getUsername()}
                      />
                    </NavLink>
                  </CustomizedTooltip>
                );
              })}
            </Box>
          }
          placement="top-end"
          enterTouchDelay={0}
        >
          <ContributorsContainer max={5}>
            {contributors &&
              contributors
                .filter((c: any) => c.getUsername())
                .map((contributor: any) => {
                  return (
                    <Tooltip
                      key={contributor.getUsername()}
                      title={contributor.getUsername()}
                      placement="top"
                    >
                      <Avatar
                        style={CollaboratorsStyles.contributorsPhotos}
                        src={
                          contributor.getProfilePicture()
                            ? contributor.getProfilePicture()
                            : isEnterprise
                            ? ENTERPRISE_ARTWORK_TEMPLATE
                            : "/assets/images/logo512.png"
                        }
                        onClickCapture={() => {
                          navigate(
                            `/user-profile/${contributor.getUsername()}`
                          );
                        }}
                        alt={contributor.getUsername()}
                      />
                    </Tooltip>
                  );
                })}
          </ContributorsContainer>
        </CustomizedTooltip>
      ) : (
        <ContributorsContainer max={5}>
          {contributors &&
            contributors
              .filter((c: any) => c.getUsername())
              .map((contributor: any) => {
                return (
                  <Tooltip
                    key={contributor.getUsername()}
                    title={contributor.getUsername()}
                    placement="top"
                  >
                    <Avatar
                      style={CollaboratorsStyles.contributorsPhotos}
                      src={
                        contributor.getProfilePicture()
                          ? contributor.getProfilePicture()
                          : isEnterprise
                          ? ENTERPRISE_ARTWORK_TEMPLATE
                          : "/assets/images/logo512.png"
                      }
                      onClickCapture={() => {
                        navigate(`/user-profile/${contributor.getUsername()}`);
                      }}
                      alt={contributor.getUsername()}
                    />
                  </Tooltip>
                );
              })}
        </ContributorsContainer>
      )}
      {!isSharedContentPage && (
        <MessageContainer>
          {handleOpenCollabsModal && (
            <Tooltip title="Add Collaborators">
              <IconButton
                id={isTrackConnectedToTutorial ? "step-19" : ""}
                size="small"
                sx={{ marginLeft: 1 }}
                onClickCapture={(e) => {
                  e.stopPropagation();
                  if (handleOpenCollabsModal) handleOpenCollabsModal(id!);
                }}
              >
                <ManageAccountsIcon
                  sx={{
                    ...CollaboratorsStyles.playbackIcons,
                    ...{ color: TEXT_COLOR },
                  }}
                />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Go to track chat">
            <IconButton
              id={isTrackConnectedToTutorial ? "step-20" : ""}
              sx={{ color: TEXT_COLOR }}
              aria-label="edit"
              onClickCapture={(e) => {
                e.stopPropagation();
                handleCreateGroupChat(id, trackTitle);
              }}
            >
              <MessageIcon />
            </IconButton>
          </Tooltip>
        </MessageContainer>
      )}
    </GenresAndContributorsContainer>
  );
};
